module.exports = __webpack_public_path__ + "static/media/beneficios.f722c3b8.png";